import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'
import { hasAgentsAccess } from '@/utils/agents/has-agents-access'

Vue.use(VueRouter)

const modules = require.context('./modules', false, /\.routes\.js$/)
const routes = modules.keys().reduce((acc, key) => {
  const modRoutes = modules(key).default || []
  return acc.concat(modRoutes)
}, [])

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('global/CANCEL_PENDING_REQUESTS')
  if (to.meta.requireAuth) {
    if (store.state.auth.token) {
      if (to.meta.requireAccount) {
        if (store.state.auth.account.id) {
          if (to.meta.requireAgents && !hasAgentsAccess(store.state.auth.account.id)) {
            next({ name: 'AccountDashboard' })
          } else {
            next()
          }
        } else {
          next({ path: '/account/choose' })
        }
      } else {
        next()
      }
    } else {
      next({
        path: '/auth/signin',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title + ' - Piriod' : 'Piriod'
  next(true)
})

export default router
